<template>
  <div>
    <div v-show="isShow" class="list-group-item list-group-item-action border-bottom p-0">
      <div class="px-3 py-3" :class="isRead ? 'bg-dark' : ''" @click="showDetailModal()">
        <div class="d-flex justify-content-between">
          <h3 class="fs-5"><i :class="isRead ? 'cil-envelope-open pe-2' : 'cil-envelope-closed pe-2'"></i>システム</h3>
          <span>{{ $moment(row.mailed_at).locale('ja').format('l(ddd)HH:mm') }}</span>
        </div>
        <div class="text-truncate">{{ row.subject }}</div>
      </div>
    </div>
    <teleport to="body">
      <mail-detail-modal ref="mailDetailModal" :row="row" />
    </teleport>
  </div>
</template>

<script>
import {mapMutations} from 'vuex';
import MailDetailModal from "@/views/molecules/modals/MailDetailModal";

export default {
  name: "NotificationAreaData",
  components: {
    MailDetailModal,
  },
  provide: {
    bindModule: 'mail_history_form'
  },
  inject: [
    '$moment',
  ],
  props: {
    unreadChecked: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      is_read: false,
    }
  },
  computed: {
    isShow() {
      if (this.unreadChecked) {
        return !this.row.is_read;
      } else {
        return true;
      }
    },
    isRead() {
      return this.row.is_read;
    },
  },  
  methods: {
    ...mapMutations('mail_history_form', [
      'updateIsRead',
    ]),
    showDetailModal() {
      this.$refs.mailDetailModal.show();
      if (!this.row.is_read) {
        sessionStorage.setItem('hideApiLoading', 'true');
        this.$store.dispatch('mail_history_form/updateIsRead', {
          id: this.row.id,
          is_read: true
        }).then(() => {
          this.$emit('update');
        }).catch(() => {
          this.$root.failApi();
        }).finally(() => {
          sessionStorage.removeItem('hideApiLoading');
        });
      }
    },
  },
}
</script>